import BaseModel from '@/bundles/App/models/BaseModel';
import { IAdCampaign, IAdCampaignItem } from '@/bundles/Ad/interfaces';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';
import { AdCampaignItemMediaType } from '@/bundles/Ad/types';

export default class AdCampaignItem extends BaseModel implements IAdCampaignItem {
  campaign?: IAdCampaign;
  clicks: number;
  image: string;
  impressions: number;
  last_shown_at: Date;
  url: string;
  media_type: AdCampaignItemMediaType;
  media: string[];
  order?: number;

  constructor (props: IAdCampaignItem) {
    super(props);
    if (props.campaign) {
      this.campaign = new AdCampaign(props.campaign);
    }
    this.clicks = props.clicks;
    this.image = props.image;
    this.impressions = props.impressions;
    this.last_shown_at = props.last_shown_at;
    this.url = props.url;
    this.media = props.media;
    this.media_type = props.media_type;
    this.order = props.order;
  }
}
